module.exports = __webpack_public_path__ + "assets/img/fusionGateway-module4-7.588ee061.jpg";